import client from '../client';
import endpoints from '../endpoints';

/**
 * OTA 채널·동기화 로그 — 관리자 API
 * AUDIT_G30: Klook / Viator / Trip.com 채널 메타 등록·활성화 토글·인바운드 로그 조회.
 *
 * BE: app/routers/admin/ota.py (4 endpoints) + /webhook/{channel} (1 endpoint)
 * 현재 인바운드 only — Outbound API Key 입력 받지만 호출 흐름은 v2 백로그.
 */

/** GET /api/admin/ota/channels — 채널 목록 */
export const adminListOtaChannels = async () => {
  const res = await client.get(endpoints.admin.ota.channels);
  return res.data;
};

/** POST /api/admin/ota/channels — 채널 등록 */
export const adminCreateOtaChannel = async (data) => {
  const res = await client.post(endpoints.admin.ota.channels, data);
  return res.data;
};

/** PUT /api/admin/ota/channels/{id} — 채널 수정 (활성화·키 갱신) */
export const adminUpdateOtaChannel = async (id, data) => {
  const res = await client.put(endpoints.admin.ota.channelDetail(id), data);
  return res.data;
};

/** DELETE /api/admin/ota/channels/{id} — 채널 삭제 */
export const adminDeleteOtaChannel = async (id) => {
  const res = await client.delete(endpoints.admin.ota.channelDetail(id));
  return res.data;
};

/** GET /api/admin/ota/sync-logs?page=&size= — 동기화 이력 (페이지네이션) */
export const adminListOtaSyncLogs = async (params = {}) => {
  const res = await client.get(endpoints.admin.ota.syncLogs, { params });
  return res.data;
};
